import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=c5191820&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=c5191820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5191820",
  null
  
)

export default component.exports